import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

import { LeistungProvider } from '../../providers/leistung/leistung';

import { SelectMitarbeiterPage } from '../select-mitarbeiter/select-mitarbeiter';
import { SelectProjectPage } from '../select-project/select-project';
import { SelectLeistungPage } from '../select-leistung/select-leistung';
import { LeistungstextPage } from '../leistungstext/leistungstext';

@IonicPage()
@Component({
  selector: 'page-leistung-detail',
  templateUrl: 'leistung-detail.html',
})
export class LeistungDetailPage {

  constructor(public navCtrl: NavController, 
  	public navParams: NavParams, 
  	public leistungCtrl: LeistungProvider) {

  	this.leistungCtrl.initEditLeistung(navParams.data);

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad LeistungDetailPage');
  }

  changeLeistung(){

   this.leistungCtrl.changeLeistung().subscribe(item => {
      this.navCtrl.pop();  
    })
    

  }
  deleteLeistung(){
    this.leistungCtrl.deleteLeistung().subscribe(item => {
      this.navCtrl.pop();  
    })
  }

  openPageMitarbeiterProject(){
    if (this.leistungCtrl.leistungEdit.Verrechnet==false){
      this.navCtrl.push(SelectMitarbeiterPage, {create:false});
    }
  }

  openPageSelectProject(){
    if (this.leistungCtrl.leistungEdit.Verrechnet==false){
  	  this.navCtrl.push(SelectProjectPage, {create:false});
    }
  }

  openPageSelectLeistung(){
    if (this.leistungCtrl.leistungEdit.Verrechnet==false){
  	  this.navCtrl.push(SelectLeistungPage, {create:false});
    }
  }

  openPageLeistungstext(){
    if (this.leistungCtrl.leistungEdit.Verrechnet==false){
  	  this.navCtrl.push(LeistungstextPage, {create:false});
    }
  }
  openPageSelectMitarbeiter(){
    if (this.leistungCtrl.leistungEdit.Verrechnet==false){
  	  this.navCtrl.push(SelectMitarbeiterPage, {create:false});
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/leistung-detail/leistung-detail.ts